export const MAX_IMAGES = 5;
export const MAX_IMAGE_BYTES = 8 * 1024 * 1024;
export const MAX_IMAGE_DIMENSION = 1024;
export const VOICE_PHOTO_INPUT_ID = 'husl-agent-voice-photo-input';

export function downscaleImage(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error('read-failed'));
    reader.onload = () => {
      const img = new Image();
      img.onerror = () => reject(new Error('decode-failed'));
      img.onload = () => {
        const scale = Math.min(1, MAX_IMAGE_DIMENSION / Math.max(img.width, img.height));
        const width = Math.round(img.width * scale);
        const height = Math.round(img.height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          resolve(reader.result as string);
          return;
        }
        ctx.drawImage(img, 0, 0, width, height);
        resolve(canvas.toDataURL('image/jpeg', 0.8));
      };
      img.src = reader.result as string;
    };
    reader.readAsDataURL(file);
  });
}

export async function readImageFiles(files: FileList | File[]): Promise<{ images: string[]; error?: string }> {
  const list = Array.from(files);
  const images: string[] = [];
  let sawError = '';

  for (const file of list) {
    if (!file.type.startsWith('image/')) {
      sawError = 'Please choose image files only.';
      continue;
    }
    if (file.size > MAX_IMAGE_BYTES) {
      sawError = 'Some images were too large (max 8MB each).';
      continue;
    }
    try {
      images.push(await downscaleImage(file));
    } catch {
      sawError = 'Could not read one of those images. Try another.';
    }
  }

  return { images, error: sawError || undefined };
}
